import { Component, OnInit } from '@angular/core';
import { WizardPageComponent } from 'src/app/core/wizard/wizard-page-component';
import type { SqftWarningWizard } from '../sqft-warning-wizard';
import { LowerCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mtn-sqft-warning',
  standalone: true,
  imports: [LowerCasePipe,TranslateModule],
  templateUrl: './sqft-warning.component.html',
  styleUrl: './sqft-warning.component.scss'
})
export class SqftWarningComponent  extends WizardPageComponent<SqftWarningWizard> implements OnInit{
  key = 'sqft-warning';

  ngOnInit(): void {
    this.title =`Caution: SQFT Value ${this.wizard.model.avg} Expected Range`;
    this.isActionButtonEnabled = true;
    this.closeButtonText = 'Continue';
    this.actionButtonText = 'Update SQFT';
  }

  onAction():any{
    this.wizard.model.updateSqft = 'YES';
    this.close()
  }

  onCrossButtonEvent():any{
    this.wizard.model.updateSqft = 'CLEAR';
    this.close();
  }
}
